import { LoginResponse, AuthRole } from "./auth.interfaces";

// Usuários pré-definidos
const MOCK_USERS = [
  {
    email: "admin@example.com",
    password: "Password@12345",
    name: "Administrador",
    role: AuthRole.Admin,
    id: "admin-123"
  },
  {
    email: "student@example.com",
    password: "Password@12345",
    name: "Estudante",
    role: AuthRole.Student,
    id: "student-456"
  }
];

export const login = async (email: string, password: string): Promise<LoginResponse> => {
  // Buscar usuário pelo email
  const user = MOCK_USERS.find(user => user.email === email);
  
  // Verificar se o usuário existe e a senha está correta
  if (!user || user.password !== password) {
    throw new Error('Credenciais inválidas');
  }
  
  // Criar JWT mock com as informações do usuário
  const header = { alg: 'none', typ: 'JWT' };
  const payload = {
    sub: user.id,
    name: user.name,
    email: user.email,
    role: user.role,
    exp: Math.floor(Date.now() / 1000) + (60 * 60) // 1 hora a partir de agora
  };

  const headerBase64 = btoa(JSON.stringify(header));
  const payloadBase64 = btoa(JSON.stringify(payload));
  
  return {
    token: `${headerBase64}.${payloadBase64}.signature`
  };
};
